export default __webpack_public_path__ + "static/media/Jump (4).f5bc5969.png";